import React from "react";
import PropTypes from "prop-types";

import { MagazineIssueCard } from "../../atoms/magazine-issue-card/index";
import SliderMain from "../../atoms/slider-main/index";
import { StoryCardML4x3DP2x1 } from "../../atoms/story-card-ml4x3-dp2x1/index";

import styles from "./styles.m.css";

export const MagazineIssueOneSliderThreeCards = ({ collection, prevIssue, nextIssue, config }) => {
  const stories = collection.items.filter(({ story = {} }) => story.headline && story.url).map(item => item.story);
  return (
    <div className={styles.base}>
      <div className={`container row ${styles["grid"]}`}>
        <MagazineIssueCard
          className={styles.issue}
          collection={collection}
          prevIssue={prevIssue}
          nextIssue={nextIssue}
          config={config}
        />
        <div className={styles["slider-stories-wrap"]}>
          <SliderMain stories={stories.slice(0, 5)} />
        </div>
        {stories.slice(5, 8).map((story, index) => (
          <StoryCardML4x3DP2x1 key={story.id} story={story} className={styles["story-card"]} />
        ))}
      </div>
    </div>
  );
};

MagazineIssueOneSliderThreeCards.propTypes = {
  collection: PropTypes.any,
  prevIssue: PropTypes.any,
  nextIssue: PropTypes.any,
  config: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string
      })
    ),
    magazines: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        magazineSlug: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
        vikatanMagazineId: PropTypes.number
      })
    ),
    "publisher-name": PropTypes.string
  })
};
MagazineIssueOneSliderThreeCards.storyLimit = 8;

export default MagazineIssueOneSliderThreeCards;
